import { mediaQueryService } from '@owc-utils/MediaQueryService/MediaQueryUtils';
import { MediaQueryChangeEvent } from '@workbench/core';
import Vue from 'vue';

const MODAL_MEDIA = ['mq1', 'mq2', 'mq3'];

export const isMobile = MODAL_MEDIA.includes(mediaQueryService.getCurrentMediaQuery());

export let isMobileLayout = Vue.observable(isMobile);

export const updateLayout = (event: CustomEvent<MediaQueryChangeEvent>): void => {
  isMobileLayout = MODAL_MEDIA.includes(event?.detail?.current);
};
